import { ROUTES } from 'src/constants'

export const accountAdminRoutes = [ROUTES.ACCOUNT_SUPPORT, ROUTES.ACCOUNT]
export const accountUserRoutes = [
  ROUTES.DASHBOARD,
  ROUTES.PRODUCTS,
  ROUTES.IMPACTS,
  ROUTES.STEPS,
  ROUTES.JOURNEYS,
]
